export default {
	setLanguage(state, language) {
		localStorage.setItem('selected_lang', language)
		state.selected_language = language
	},
}
